export const iconFontAwesomeEducationAward = (
	<i className="fa-solid fa-award"></i>
);
